import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private visitorApiUrl = `${environment.baseUrl.replace('/v1/', '/api/v1/')}visitor-management/`;

  constructor(private http: HttpClient) {}

  getRegisters(page: number = 1, pageSize: number = 10, searchText: string = '', locationId?: number): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (locationId) {
      params = params.set('location_id', locationId.toString());
    }
    return this.http.get(`${this.visitorApiUrl}registers/`, { params });
  }

  getRegister(id: number): Observable<any> {
    return this.http.get(`${this.visitorApiUrl}registers/${id}/`);
  }

  createRegister(payload: any): Observable<any> {
    return this.http.post(`${this.visitorApiUrl}registers/`, payload);
  }

  updateRegister(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.visitorApiUrl}registers/${id}/`, payload);
  }

  deleteRegister(id: number): Observable<any> {
    return this.http.delete(`${this.visitorApiUrl}registers/${id}/`);
  }

  listLocations(page: number = 1, pageSize: number = 200, searchText: string = ''): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText) {
      params = params.set('search', searchText);
    }
    return this.http.get(`${environment.baseUrl}locations/`, { params });
  }
}
